var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2903_1027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4997 2.08334C18.2528 2.08334 22.9163 6.74689 22.9163 12.5C22.9163 18.2531 18.2528 22.9167 12.4997 22.9167C6.74655 22.9167 2.08301 18.2531 2.08301 12.5C2.08301 6.74689 6.74655 2.08334 12.4997 2.08334ZM12.4893 10.4167H11.458C11.1925 10.417 10.9371 10.5186 10.7441 10.7009C10.551 10.8832 10.4348 11.1323 10.4193 11.3973C10.4037 11.6623 10.49 11.9233 10.6604 12.1269C10.8308 12.3305 11.0725 12.4614 11.3361 12.4927L11.458 12.5V17.6979C11.458 18.2396 11.8684 18.6875 12.3955 18.7438L12.5101 18.75H13.0205C13.2396 18.75 13.4531 18.681 13.6306 18.5526C13.8082 18.4243 13.9408 18.2433 14.0096 18.0353C14.0783 17.8273 14.0797 17.6029 14.0136 17.394C13.9475 17.1852 13.8173 17.0025 13.6413 16.8719L13.5413 16.8063V11.4688C13.5413 10.9271 13.1309 10.4792 12.6038 10.4229L12.4893 10.4167ZM12.4997 7.29168C12.2234 7.29168 11.9585 7.40142 11.7631 7.59677C11.5678 7.79212 11.458 8.05708 11.458 8.33334C11.458 8.60961 11.5678 8.87456 11.7631 9.06991C11.9585 9.26526 12.2234 9.37501 12.4997 9.37501C12.7759 9.37501 13.0409 9.26526 13.2362 9.06991C13.4316 8.87456 13.5413 8.60961 13.5413 8.33334C13.5413 8.05708 13.4316 7.79212 13.2362 7.59677C13.0409 7.40142 12.7759 7.29168 12.4997 7.29168Z",
    fill: "#414141"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2903_1027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventInfo);
export default __webpack_public_path__ + "static/media/EventInfo.e57c5e1bf047f1667619a053273c2cf2.svg";
export { ForwardRef as ReactComponent };